import { render, staticRenderFns } from "./FinancialChannelTypeStatistics.vue?vue&type=template&id=7c4881d2&"
import script from "./FinancialChannelTypeStatistics.vue?vue&type=script&lang=ts&"
export * from "./FinancialChannelTypeStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinancialChannelTypeStatistics.vue"
export default component.exports